import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import UserService from "../Services/UserList";
import Swal from "sweetalert2";
import MainLayout from "./admin/MainLayout";
import Loader from "./utils/Loader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  TablePagination,
  TextField,
  Box,
  IconButton,
  Stack,
  Grid,
  TableSortLabel,
  InputAdornment,
  Modal,
  Divider,
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
  Tooltip
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,

} from "@mui/material";
import * as XLSX from "xlsx"; // Import the xlsx library
import { saveAs } from "file-saver"; // Import file-saver for saving files
import MultipleStopIcon from '@mui/icons-material/MultipleStop';
import { BlockOutlined, Search } from "@mui/icons-material";
import TableChartIcon from "@mui/icons-material/TableChart";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchClient, fetchRegion, fetchState } from "../redux/slices/clientSlice";
import LoadingIndicator from "./utils/LoadingIndicator";
import { TableBodySkeleton } from "./utils/TableSkeleton";
import MultiSelectWithCheckbox from "./utils/MultiSelectWithCheckbox";
import { ClickableTableLink } from "./admin/ClickableTableLink";
import { Container, Edit } from "lucide-react";
import Apiurl from "../Helpers/apiUrl";
import axios from "axios";
import MonthFY from "./MonthFY";
import YearFY from "./YearFY";
import FilterBar2 from "./admin/admin_dashboard/FilterBar2";

const FY_YEAR_OPTIONS = [
  { label: "2026-2027", value: "2026" },
  { label: "2025-2026", value: "2025" },
  { label: "2024-2025", value: "2024" },
  { label: "2023-2024", value: "2023" },
];

export default function AdminClientList() {

  const { state } = useLocation();
  const dispatch = useDispatch();
  const { regionOpt, stateOpt } = useSelector((state) => state.adminOption);
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState(state && state?.search || "");
  const [month, setMonth] = useState(() => {
    if (state && state.months !== undefined) {
      if (Array.isArray(state.months) && state.months.length === 0) return [];
      return state.months;
    }

    const fullFYMonths = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
    const currentCalendarMonth = new Date().getMonth() + 1;
    const currentMonthIndex = fullFYMonths.indexOf(currentCalendarMonth);
    return fullFYMonths.slice(0, currentMonthIndex + 1);
  });
  const [year, setYear] = useState(() => {
    if (state && state.years !== undefined) {
      if (Array.isArray(state.years) && state.years.length === 0) return [];
      const targetYrs = state.years.map(String);
      return FY_YEAR_OPTIONS.filter((y) => targetYrs.includes(y.value));
    }
    const currentYrStr = String(new Date().getFullYear());
    return FY_YEAR_OPTIONS.filter((y) => y.value === currentYrStr);
  });
  const [filterByClientCreatedAt, setFilterByClientCreatedAt] = useState(() => {
    if (state && state.hasOwnProperty('filterByClientCreatedAt')) {
        return state.filterByClientCreatedAt;
    }
    return true; 
  });
  const [channelOpt, setChannelOpt] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedDate, setSelectedDate] = useState("");
  const { stateData, regionData, clientDatas, count, status } = useSelector((state) => state.client);
  const [onEdit, setOnEdit] = useState(false);
  const [modal, setModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    client_name: "",
    id: "",
    site_add: "",
    afd: "",
    add_to: "",
    username: "",
    city: "",
    state: "",
    pin: "",
    email: "",
    phone: "",
  });


  const initialFromDate = (() => {
    if (state?.years && state?.monthFrom !== undefined) {
      return `${state.years}-${String(state.monthFrom).padStart(2, "0")}-01`;
    }
    return null;
  })();

  const initialToDate = (() => {
    if (state?.years && state?.monthTo !== undefined) {
      const lastDay = new Date(Number(state.years), state.monthTo, 0).getDate();
      return `${state.years}-${String(state.monthTo).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
    }
    return null;
  })();

  const [fromDate, setFromDate] = useState(
    state && initialFromDate ? initialFromDate : null
  );
  const [toDate, setToDate] = useState(
    state && initialToDate ? initialToDate : null
  );
  const [selectedRegion, setSelectedRegion] = useState(() => {
    if (state?.regions && state.regions.length > 0 && regionOpt) {
      return regionOpt.filter((reg, idx) =>
        state.regions.includes(idx) ||
        state.regions.includes(idx + 1) ||
        state.regions.some(val => String(val).toLowerCase() === String(reg.value).toLowerCase())
      );
    }
    return [];
  });

  const [selectedState, setSelectedState] = useState(() => {
    if (state?.states && state.states.length > 0 && stateOpt) {
      return stateOpt.filter((st, idx) =>
        state.states.includes(idx) ||
        state.states.includes(idx + 1) ||
        state.states.some(val => String(val).toLowerCase() === String(st.value).toLowerCase())
      );
    }
    return [];
  });

  const counts = count || 0;
  const [sortBy, setSortBy] = useState({
    sort_by: "",
    order: "desc",
  });

  useEffect(() => {
    dispatch(
      fetchClient({
        search: searchQuery,
        state: selectedState?.map((u) => u.value),
        region: selectedRegion?.map((u) => u.value),
        channel: selectedChannels?.map((u) => u.value),
        from: fromDate,
        to: toDate,
        page: page,
        rowsPerPage: rowsPerPage,
        sort_by: sortBy.sort_by,
        sort_order: sortBy.order,
        month: month,
        year: year?.map((y) => y.value),
        filterByClientCreatedAt: filterByClientCreatedAt,
      })
    );
  }, [searchQuery, selectedRegion, selectedState, selectedChannels, fromDate, toDate, page, rowsPerPage, sortBy, month, year, filterByClientCreatedAt]);

  useEffect(() => {
    UserService.GetChannels().then(response => {
      if (response && response.data) {
        setChannelOpt(response.data.map(ch => ({
          value: ch.id,
          label: ch.channel_name
        })));
      }
    }).catch(console.error);
    dispatch(fetchRegion());
  }, []);

  useEffect(() => {
    dispatch(fetchState({ id: regionData?.find(r => r.name === selectedRegion?.value)?.id }));
  }, [selectedRegion]);


  const filterConfigs = [
    { id: "region", label: "Region", options: regionOpt || [], selected: selectedRegion },
    { id: "state", label: "State", options: stateOpt || [], selected: selectedState },
    { id: "channel", label: "Channel", options: channelOpt || [], selected: selectedChannels },
    { id: "year", label: "Year (FY)", options: FY_YEAR_OPTIONS, selected: year },
  ];

  const handleFilterChange = (filterId, nextSelected) => {
    switch (filterId) {
      case "region": setSelectedRegion(nextSelected); break;
      case "state": setSelectedState(nextSelected); break;
      case "channel": setSelectedChannels(nextSelected); break;
      case "year": setYear(nextSelected); break;
      default: break;
    }
  };

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Function to handle Excel download
  const handleDownloadExcel = () => {
    const filteredData = clientDatas?.map((user) => ({
      id: user.id,
      username: user.username,
      user_type: user.user_type,
      channel: user.channel_name || "N/A",
      emp_code: user.emp_code,
      client_name: user.client_name,
      site_add: user.site_add,
      email: user.email,
      phone: user.phone,
      add_to: user.add_to,
      user_id: user.user_id,
      region: user.city,
      state: user.state,
      pincode: user.pin,
      afd: user.afd,
      created_at: new Date(user.created_at).toISOString().split("T")[0],
      updated_at: user.updated_at,
    }));

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Client");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "ClientList.xlsx"); // Save the Blob as an Excel file
  };

  const handleClearFilters = () => {
    setSearchQuery("");
    setFromDate(null);
    setToDate(null);
    setSelectedRegion([]);
    setSelectedState([]);
    setSelectedChannels([]);
    setSortBy({ sort_by: "", order: "desc" });

    const fullFYMonths = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
    const currentCalendarMonth = new Date().getMonth() + 1;
    const currentMonthIndex = fullFYMonths.indexOf(currentCalendarMonth);
    setMonth(fullFYMonths.slice(0, currentMonthIndex + 1));

    const currentYrStr = String(new Date().getFullYear());
    setYear(FY_YEAR_OPTIONS.filter((y) => y.value === currentYrStr));
  };

  const handleSort = (column) => {
    setSortBy((prev) => {
      if (prev.sort_by === column) {
        return {
          sort_by: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      }
      return { sort_by: column, order: "asc" };
    });
  };

  // Form validation logic
  const validateForm = () => {
    let errors = {};
    if (!formData.client_name) {
      errors.client_name = "Client Name is required";
    } else if (!/^[a-zA-Z0-9\s]+$/.test(formData.client_name)) {
      errors.client_name = "Special characters are not allowed in Client Name";
    }
    if (!/^\d{10}$/.test(formData.phone)) {
      errors.phone = "Phone Number must be exactly 10 digits";
    }
    if (!formData.city) {
      errors.city = "City is required";
    }
    if (!formData.state) {
      errors.state = "State is required";
    }
    return errors;
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: "" });
    setFormData({ ...formData, [name]: value });
  };

  // Initialize form for editing
  const editClient = (client) => {
    setOnEdit(true);
    setFormData({
      id: client.id,
      client_name: client.client_name,
      site_add: client.site_add,
      city: client.city,
      state: client.state,
      pin: client.pin,
      add_to: client.add_to,
      afd: client.afd,
      email: client.email,
      phone: client.phone,
    });
    setModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const token = localStorage.getItem("u_token");

      const response = await axios.post(
        `${Apiurl}admin/userlist/client/update`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.data?.status || response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Client Updated",
          text: "Client updated successfully",
          timer: 3000,
        });
        setModal(false);
        setOnEdit(false);

        // Refresh grid
        dispatch(fetchClient({
          search: searchQuery,
          state: selectedState?.map((u) => u.value),
          region: selectedRegion?.map((u) => u.value),
          from: fromDate,
          to: toDate,
          page: page,
          rowsPerPage: rowsPerPage,
          sort_by: sortBy.sort_by,
          sort_order: sortBy.order,
          month: month,
          year: year,
        }));
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to update client. Please try again later.",
      });
    }
  };

  useEffect(() => {
    if (formData.city) {
      const matchedRegion = regionData?.find(r => r.name === formData.city);
      if (matchedRegion) {
        dispatch(fetchState({ id: matchedRegion.id }));
      }
    }
  }, [formData.city, regionData, dispatch]);

  return (
    <MainLayout title={'Clients'}>
      {(status === "pending" || loading) && null}

      <div style={{ height: "calc(100vh - 90px)", display: 'flex', flexDirection: 'column' }}>
        <div className="bg-white/95 backdrop-blur-sm shadow-sm pb-2 pt-2 -mt-2 mb-2 rounded-lg shrink-0 relative z-20">
          <FilterBar2
            filters={filterConfigs}
            onFilterChange={handleFilterChange}
            selectedMonth={month}
            setSelectedMonth={setMonth}
            searchTerm={searchQuery}
            setSearchTerm={setSearchQuery}
            selectedFromDate={fromDate}
            setSelectedFromDate={setFromDate}
            selectedToDate={toDate}
            setSelectedToDate={setToDate}
            onClearFilters={handleClearFilters}
            actions={
              <div className="flex items-center gap-2">
                <Button
                  variant="contained"
                  startIcon={<TableChartIcon />}
                  onClick={handleDownloadExcel}
                  sx={{
                    textTransform: "none",
                    bgcolor: "#2e7d32",
                    py: "2px",
                    px: "14px",
                    borderRadius: 12,
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    "&:hover": { bgcolor: "#1b5e20" },
                  }}
                >
                  Excel
                </Button>
              </div>
            }
          />
        </div>

      <Paper elevation={3} style={{}}>
        <TableContainer sx={{ maxHeight: "calc(100vh - 240px)" }}>
          <Table stickyHeader>
            <TableHead sx={{ background: "#04121f", color: "white", "& th": { backgroundColor: "#04121f", color: "white" } }}>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  SL No.
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "username"}
                    direction={
                      sortBy.sort_by === "username" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("username")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >

                    User Name
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  User Type
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Channel
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  EMP Code/GST No.
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Client Id
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "client"}
                    direction={
                      sortBy.sort_by === "client" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("client")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >

                    Client Name
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Transferred From
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Billing Address
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "region"}
                    direction={
                      sortBy.sort_by === "region" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("region")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >

                    Region
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "state"}
                    direction={
                      sortBy.sort_by === "state" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("state")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >

                    State
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Pin Code
                </TableCell>

                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  <TableSortLabel
                    active={sortBy.sort_by === "architect_firm"}
                    direction={
                      sortBy.sort_by === "architect_firm" ? sortBy.order : "desc"
                    }
                    onClick={() => handleSort("architect_firm")}
                    hideSortIcon={false} // <-- keep icon visible even when inactive
                    sx={{
                      color: "white !important",
                      cursor: "pointer",
                      "& .MuiTableSortLabel-icon": {
                        opacity: 1, // <-- don't fade when inactive
                        color: "white !important",
                      },
                    }}
                  >

                    Architect Firm
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "190px", whiteSpace: "nowrap" }}
                >
                  Email
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Phone
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Site Address
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Create At
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Time
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Updated  At
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Update Time
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", width: "150px", whiteSpace: "nowrap" }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clientDatas?.length > 0 ? (
                clientDatas?.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell align="center">
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell align="center"><ClickableTableLink path="/admin/userlist" displayValue={item.username} searchValue={item.emp_code} date={item.user_created_at ? item.user_created_at.substring(0, 4) : null} /></TableCell>
                    <TableCell align="center">{item.user_type}</TableCell>
                    <TableCell align="center">{item.channel_name || "N/A"}</TableCell>
                    <TableCell align="center">{item.emp_code}</TableCell>
                    <TableCell align="center">{item.id}</TableCell>
                    <TableCell align="center">
                      <div className="flex items-center gap-2">
                        <span>{item.client_name}</span>
                        {item.transferred_user_name && (
                          <span className="relative flex h-5 w-5">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 "></span>
                            <span className="relative inline-flex items-center justify-center rounded-full h-5 w-5 bg-orange-600 text-white text-[10px] font-bold">
                              T
                            </span>
                          </span>
                        )}
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="caption" sx={{ color: "#757574" }}>
                        {item.transferred_user_name ? item.transferred_user_name : "Not Transferred"}
                      </Typography>
                    </TableCell>
                    <TableCell
                      style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '200px',
                      }}
                    >
                      {item.site_add}
                    </TableCell>
                    <TableCell align="center">{item.city}</TableCell>
                    <TableCell align="center">{item.state}</TableCell>
                    <TableCell align="center">{item.pin}</TableCell>
                    <TableCell align="center">{item.afd}</TableCell>
                    <TableCell align="center">{item.email}</TableCell>
                    <TableCell align="center">{item.phone}</TableCell>
                    <TableCell align="center">{item.add_to}</TableCell>
                    <TableCell align="center">
                      {new Date(item.created_at).toLocaleDateString("en-GB")}
                    </TableCell>
                    <TableCell align="center">
                      {new Date(item.created_at).toLocaleString("en-GB", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </TableCell>
                    <TableCell align="center">
                      {item ? new Date(item.updated_at).toLocaleDateString("en-GB") : ""}
                    </TableCell>
                    <TableCell align="center">
                      {new Date(item.updated_at).toLocaleString("en-GB", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </TableCell>
                    <TableCell align="center">
                      <button
                        onClick={() => editClient(item)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                      >
                        <Tooltip title={"Edit Client"} arrow>
                          <Edit
                             className="bg-blue-600 text-white hover:bg-blue-300 hover:text-blue-600 p-1 rounded-full scale-110"
                             style={{ fontSize: "30px" }}
                          />
                        </Tooltip>
                      </button>
                    </TableCell>
                  </TableRow>
                )
                )
              ) : (status === 'pending' || loading) ? (
                <TableBodySkeleton cols={25} rows={10} hasActions />
              ) : (
                <TableRow>
                  <TableCell colSpan={25} align="center">
                    No clients found
                  </TableCell>
                </TableRow>

              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            marginTop: "1rem",
          }}
          rowsPerPageOptions={[10, 20, 50, 100, counts]}
          component="div"
          count={counts}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      </div>

      <Dialog
        open={modal}
        onClose={() => {
          setModal(false);
          setOnEdit(false);
          setErrors({});
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 1 }
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: "1.25rem", color: "#04121f", pb: 1 }}>
          Update Client Details
        </DialogTitle>

        <Divider sx={{ mb: 2 }} />

        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid container spacing={2.5}>
              {[
                { label: "Client Name *", name: "client_name", error: errors.client_name },
                { label: "Billing Address *", name: "site_add", error: errors.site_add },
                { label: "Region *", name: "city", error: errors.city, type: "select", options: regionData || [] },
                { label: "State *", name: "state", error: errors.state, type: "select", options: stateData || [] },
                { label: "Pin Code", name: "pin", error: errors.pin },
                { label: "Architect Firm Details", name: "afd", error: errors.afd },
                { label: "Email", name: "email", error: errors.email },
                { label: "Phone *", name: "phone", error: errors.phone },
                { label: "Site Address *", name: "add_to", error: errors.add_to },
              ].map(({ label, name, error, type, options }, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  {type === "select" ? (
                    <FormControl fullWidth variant="outlined" size="small" error={!!error}>
                      <InputLabel>{label}</InputLabel>
                      <MuiSelect
                        label={label}
                        name={name}
                        value={formData[name] || ""}
                        onChange={handleChange}
                        sx={{ backgroundColor: "#fff" }}
                      >
                        <MenuItem value="">
                          <em>Select {label}</em>
                        </MenuItem>
                        {options?.map((option) => (
                          <MenuItem key={option.id} value={option.name}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </MuiSelect>
                      {error && <FormHelperText>{error}</FormHelperText>}
                    </FormControl>
                  ) : (
                    <TextField
                      label={label}
                      fullWidth
                      variant="outlined"
                      size="small"
                      name={name}
                      value={formData[name] || ""}
                      onChange={handleChange}
                      error={!!error}
                      helperText={error}
                      sx={{ backgroundColor: "#fff" }}
                    />
                  )}
                </Grid>
              ))}
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: 3, pt: 1, justifyContent: "flex-end", gap: 1.5 }}>
            <Button
              onClick={() => {
                setModal(false);
                setOnEdit(false);
                setErrors({});
              }}
              variant="outlined"
              sx={{
                px: 3,
                color: "#546e7a",
                borderColor: "#cfd8dc",
                textTransform: "none",
                "&:hover": { bgcolor: "#f4f6f7", borderColor: "#b0bec5" }
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{
                px: 4,
                fontWeight: "bold",
                bgcolor: "#0288d1",
                textTransform: "none",
                "&:hover": { bgcolor: "#01579b" }
              }}
            >
              Save Changes
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </MainLayout>
  );
}

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    width: 200,
    borderColor: state.isFocused ? "#0288d1 !important" : "#c4c4c4",
    boxShadow: state.isFocused ? "0 0 0 1px #0288d1" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#0288d1" : "#a0a0a0",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  placeholder: (base) => ({
    ...base,
    color: "#a0a0a0",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    width: 200,

  }),
};